<template>
    <table width="266" cellpadding="0" cellspacing="0" style="font-size: 14px;">
        <tr>
            <td colspan="2" align="center"><img @load="imgLoad++" style="max-width: 50%;" v-bind:src="'/assets/kiosk/img/stores/'+this.$root.store_uid+'/'+this.$root.borne_configuration.logo_print_url"></td>
        </tr>
        <tr>
            <td colspan="2" height="20"></td>
        </tr>
        <tr>
            <td colspan="2" align="center" style="border: solid 1px #000; padding:10px;">
                <div>{{this.store['name']}}</div>
                <div>{{this.store['adresse']}}</div>
                <div>{{this.store['ville']}} {{this.store['province']}} {{this.store['code_postal']}}</div>
                <div>{{this.store['tel']}}</div>
            </td>
        </tr>
        <tr>
            <td colspan="2" height="20"></td>
        </tr>
        <tr>
            <td>{{ this.trans.get('orders.no-order') }}</td>
            <td align="right" width="100px">{{this.no_commande}}</td>
        </tr>
        <tr>
            <td>{{ this.trans.get('orders.Invoice') }} #{{ this.no_invoice }}</td>
            <td align="right">{{this.date_invoice}}</td>
        </tr>
        <tr>
            <td height="10" colspan="2"></td>
        </tr>
        <tr>
            <td colspan="2" style="border-top: solid 1px #000;"></td>
        </tr>
        <tr>
            <td height="10" colspan="2"></td>
        </tr>
        <tr>
            <td>{{ this.trans.get('orders.Items') }}</td>
            <td align="right">{{ this.trans.get('orders.PRICE') }}</td>
        </tr>
        <tr v-for="item in this.items">
            <td>1 X {{item['product_name']}}</td>
            <td align="right" v-text="format_Currency(item['price'])"></td>
        </tr>
        <tr>
            <td height="10" colspan="2"></td>
        </tr>
        <tr>
            <td colspan="2" style="border-top: solid 1px #000;"></td>
        </tr>
        <tr>
            <td height="10" colspan="2"></td>
        </tr>
        <tr>
            <td>{{ this.trans.get('orders.SUBTOTAL') }}</td>
            <td align="right">{{ this.subtotal }}</td>
        </tr>
        <tr>
            <td height="10" colspan="2"></td>
        </tr>
        <tr>
            <td colspan="2" style="border-top: solid 1px #000;"></td>
        </tr>
        <tr>
            <td height="10" colspan="2"></td>
        </tr>
        <tr>
            <td>{{ this.trans.get('orders.Service-charge') }}</td>
            <td align="right">{{ this.frais }}</td>
        </tr>
        <tr>
            <td height="10" colspan="2"></td>
        </tr>
        <tr>
            <td colspan="2" style="border-top: solid 1px #000;"></td>
        </tr>
        <tr>
            <td height="10" colspan="2"></td>
        </tr>
        <tr v-for="(taxe, name) in this.taxes">
            <td>{{name}} <span style="font-size: 11px;">({{this.no_taxe[taxe.tax_id]}})</span></td>
            <td align="right" v-text="format_Currency(taxe['price'])"></td>
        </tr>
        <tr>
            <td>{{ this.trans.get('orders.TOTAL') }}</td>
            <td align="right">{{ this.total }}</td>
        </tr>
        <tr>
            <td height="10" colspan="2"></td>
        </tr>
        <tr>
            <td colspan="2" style="border-top: solid 1px #000;"></td>
        </tr>
        <tr>
            <td height="10" colspan="2"></td>
        </tr>
        <tr>
            <td>{{ this.method }}</td>
            <td align="right">{{ this.method_amount }}</td>
        </tr>
        <tr>
            <td height="10" colspan="2"></td>
        </tr>
        <tr>
            <td colspan="2" style="border-top: solid 1px #000;"></td>
        </tr>
        <tr>
            <td height="10" colspan="2"></td>
        </tr>
        <tr>
            <td height="20" colspan="2"></td>
        </tr>
        <tr>
            <td colspan="2"><div class="page-break"></div></td>
        </tr>
        <tr>
            <td colspan="2" align="center" style="font-size: 20px;">{{ this.trans.get('orders.TICKETS') }}</td>
        </tr>
        <tr>
            <td height="20" colspan="2"></td>
        </tr>
    </table>
    <div v-for="item in this.items">
        <div style="break-after:page"></div>
        <table width="266" cellpadding="0" cellspacing="0" style="font-size: 14px;">
            <tr >
                <td colspan="2">
                    <table cellspacing="0" cellpadding="0" width="100%">
                        <tr>
                            <td align="center">{{item['event_name']}}</td>
                        </tr>
                        <tr>
                            <td height="10"></td>
                        </tr>
                        <tr>
                            <td align="center">{{this.timestamps_convert(item['event_date'] / 1000,'date_and_time')}}</td>
                        </tr>
                        <tr>
                            <td height="10"></td>
                        </tr>
                        <tr>
                            <td align="center">{{item['product_name']}}</td>
                        </tr>
                        <tr>
                            <td height="10"></td>
                        </tr>
                        <tr v-if="item['seating_chart_infos'] != null && item['seating_chart_infos']['section'] != null && item['seating_chart_infos']['row'] != null && item['seating_chart_infos']['seat'] != null">
                            <td align="center">{{ this.trans.get('orders.Section') }}: {{item['seating_chart_infos']['section']}} {{ this.trans.get('orders.Row') }}: {{item['seating_chart_infos']['row']}} {{ this.trans.get('orders.Seat') }}: {{item['seating_chart_infos']['seat']}}</td>
                        </tr>
                        <tr>
                            <td height="20"></td>
                        </tr>
                        <tr>
                            <td align="center"><qrcode-vue :value="item['qr_url']" :size="100" level="L" /></td>
                        </tr>
                        <tr>
                            <td height="10"></td>
                        </tr>
                        <tr>
                            <td align="center">{{item['cart_item_uid']}}</td>
                        </tr>
                        <tr>
                            <td height="30"></td>
                        </tr>
                    </table>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
import {defineComponent} from "vue";
import {formatCurrency, formatTimeStamp} from "../../helpers/kiosk-helpers";
import QrcodeVue from 'qrcode.vue'

export default defineComponent({
    name: "template1",

    components: {
        QrcodeVue,
    },
    beforeMount() {
        this.store['name'] = this.invoice['data']['billing_account_infos'][0]['name'];
        this.store["adresse"] = this.invoice['data']['billing_account_infos'][0]['address'];
        this.store["ville"] = this.invoice['data']['billing_account_infos'][0]['city'];
        this.store["code_postal"] = this.invoice['data']['billing_account_infos'][0]['postal_code'];
        this.store["province"] = this.invoice['data']['billing_account_infos'][0]['province_code'];
        this.store["tel"] = this.invoice['data']['billing_account_infos'][0]['telephone'];



        this.no_commande = this.invoice['data']['order_id'];
        this.no_invoice = this.invoice['data']['invoices'][0]['idx'];
        this.date_invoice = this.timestamps_convert(this.invoice['data']['invoices'][0]['created']);
        //this.date_invoice = this.date_invoice.split(" ");
        //this.date_invoice = this.date_invoice[0];

        this.items = this.invoice['data']['cart_items'];

        this.taxes = this.invoice['data']['taxes'];

        for (const [key, value] of Object.entries(this.invoice['data']['billing_account_infos'][0]['taxes']))
        {
            this.no_taxe[value.tax_id] = value.merchant_number;
        }




        this.total = formatCurrency(this.invoice['data']['total']);
        this.subtotal = formatCurrency(this.invoice['data']['subtotal']);

        var lfrais = this.invoice['data']['fees'];

        for (const [key, frais] of Object.entries(lfrais)) {
            this.frais += parseFloat(frais['price']);
        }

        this.method = this.invoice['data']['invoices'][0]['payments'][0]['method'];
        this.method_amount = formatCurrency(this.invoice['data']['invoices'][0]['payments'][0]['amount']);


        this.frais = formatCurrency(this.frais);
    },

    created() {
        this.init();
    },
    data() {
        return {
            total: 0,
            subtotal: 0,
            frais: 0,
            no_commande: null,
            no_invoice: null,
            date_invoice: null,
            items: null,
            taxes: null,
            no_taxe: [],
            nb_image: 1,
            imgLoad: 0,
            store: [],
            method: null,
            method_amount: 0,
        }
    },
    watch: {
        imgLoad(value){
            if(value === this.nb_image)
            {
                this.create_invoice();
            }
        },

    },


    methods: {
        init()
        {



        },

        create_invoice()
        {
            //document.getElementById('print_frame').contentDocument.write(this.$parent.$refs.print_block.innerHTML);

            setTimeout(() => {
                this.print_invoice();
            }, 1000);

        },

        format_Currency(currency)
        {
            return formatCurrency(currency);
        },

        print_invoice()
        {
            window.print();
            //window.frames["print_frame"].focus();
            //window.frames["print_frame"].print();
            this.$root.invoice_loaded = false;
            this.$root.endOrder();


        },


        timestamps_convert(timestamps,format = 'date')
        {
            var date = new Date(timestamps * 1000);
            var year = date.getFullYear();
            var month = date.getMonth()+1;
            if(month < 10)
            {
                month = "0"+month;
            }
            var day = date.getDate();
            if(day < 10)
            {
                day = "0"+day;
            }
            var hour = date.getHours();
            if(hour < 10)
            {
                hour = "0"+hour;
            }
            var min = date.getMinutes();
            if(min < 10)
            {
                min = "0"+min;
            }

            if(format == 'date_and_time')
            {
                return year+"-"+month+"-"+day+ " " +hour+"H"+min;
            }
            return year+"-"+month+"-"+day;
        },


    },
    props: {
        invoice: Object,
        invoice_item_url: Array,
    },
});
</script>

<style scoped>

</style>
